import { ResponsesInteractionChannelAuditResponse } from '@genial/services/dist/models';

import { SelectedProduct } from '../../../store/product/types';

export const showChannelsCheckboxes = true;

export const getOrderNameByType = (type: SelectedProduct['type']) => {
  switch (type) {
    case 'FixedIncome':
      return 'Renda Fixa';

    case 'Fund':
      return 'Fundos';

    case 'DirectTreasury':
      return 'Tesouro Direto';

    case 'Equity':
      return 'Renda Variável';

    case 'StructuredOperations':
      return 'Operações Estruturadas';

    default:
      return 'Oportunidade';
  }
};

export const transformInteractionChannelAuditData = (
  data: ResponsesInteractionChannelAuditResponse[]
) => {
  return data?.map((item) => ({
    label: item.interactionChannelAudit.description,
    value: item.interactionChannelAudit.value,
  }));
};

export const findInteractionChannelAuditId = (
  selectedValue: string,
  data: ResponsesInteractionChannelAuditResponse[]
) => {
  const selectedItem = data.find((item) => item.interactionChannelAudit.value === selectedValue);
  return selectedItem ? selectedItem.interactionChannelAudit.interactionChannelAuditId : null;
};

export const getInteractionChannelOptions = (
  id: number | null,
  data: ResponsesInteractionChannelAuditResponse[]
) => {
  const item = data.find((obj) => obj.interactionChannelAudit.interactionChannelAuditId === id);

  if (item) {
    return item.interactionChannelAudit?.interactionChannelOptions?.map((option) => ({
      label: option.channel,
      value: option.value,
    }));
  } else {
    return [];
  }
};

export const defaultOrderInteractionChannelAuditData = [
  {
    interactionChannelAudit: {
      interactionChannelAuditId: 2,
      description: 'NÃO',
      value: 'no',
      interactionChannelOptions: [
        {
          channel: 'SMS',
          value: 'sms',
        },
        {
          channel: 'Facebook Messenger',
          value: 'facebook',
        },
        {
          channel: 'Telegram',
          value: 'telegram',
        },
        {
          channel: 'Bloomberg Chat',
          value: 'bloomberg',
        },
        {
          channel: 'WhatsApp',
          value: 'whatsApp',
        },
      ],
    },
  },
  {
    interactionChannelAudit: {
      interactionChannelAuditId: 3,
      description: 'NÃO SOLICITADA',
      value: 'not_requested',
      interactionChannelOptions: [
        {
          channel: 'Não solicitada pelo cliente',
          value: 'not_requested',
        },
      ],
    },
  },
  {
    interactionChannelAudit: {
      interactionChannelAuditId: 1,
      description: 'SIM',
      value: 'yes',
      interactionChannelOptions: [
        {
          channel: 'E-mail',
          value: 'email',
        },
        {
          channel: 'Telefone',
          value: 'phone',
        },
        {
          channel: 'Teams',
          value: 'teams',
        },
        {
          channel: 'Skype',
          value: 'skype',
        },
      ],
    },
  },
];
